import React, { useEffect } from 'react'
import styles from './BottomBar.module.css'

const Indicator = ({
    selected,
    onClick,
}) => {
    return (
        <div className={styles.indicator}
            onClick={onClick}
            style={{ backgroundColor: selected ? 'red' : 'rgba(255,255,255,0.6)' }} />
    )
}

const BottomBar = ({
    indicatorsNum,
    selectedIndicator,
    onIndicatorClick,
}) => {

    const lastIndicatorSetCheck = () => {
        if (selectedIndicator !== 0)
            onIndicatorClick(selectedIndicator)
    }
    
    useEffect(lastIndicatorSetCheck , [])

    

    return (
        <div className={styles.container}>
            <div className={styles.indicators}>
                {Array(indicatorsNum).fill(null).map((_, index) => {
                    return <Indicator
                        key={String(index)}
                        onClick={() => onIndicatorClick(index)}
                        selected={Number(selectedIndicator) === index} />
                })}
            </div>

        </div>
    )
}

export default BottomBar
